var api = require("!../../node_modules/.pnpm/style-loader@1.3.0_webpack@5.108.4/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../node_modules/.pnpm/file-loader@6.2.0_webpack@5.108.4/node_modules/file-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../node_modules/.pnpm/extract-loader@5.1.0/node_modules/extract-loader/lib/extractLoader.js!../../node_modules/.pnpm/css-loader@3.6.0_webpack@5.108.4/node_modules/css-loader/dist/cjs.js?-url!../../node_modules/.pnpm/postcss-loader@3.0.0/node_modules/postcss-loader/src/index.js!../../node_modules/.pnpm/sass-loader@16.0.8_sass-emb_f090ea1c0a17abf7c789eca5a01c1aff/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].use[5]!../../node_modules/.pnpm/sass-resources-loader@2.2.5/node_modules/sass-resources-loader/lib/loader.js??ruleSet[1].rules[1].use[6]!./admin.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};